import { Button, IconButton, useMediaQuery } from "@mui/material";
import React from "react";
// import { Container } from './styles';
import { MdFilterList } from "react-icons/md";

const FilterButton: React.FC<any> = ({ onClick, disabled }) => {
  const larguraTelaPequena = useMediaQuery("(max-width:1300px)");
  return larguraTelaPequena ? (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      style={{
        backgroundColor: "#D5DEFF",
        borderRadius: 4,
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <MdFilterList color="#2D5BFF" size={22} />
    </IconButton>
  ) : (
    <Button
      onClick={onClick}
      style={{
        backgroundColor: "#D5DEFF",
        color: "#2D5BFF",
        textTransform: "none",
        boxShadow: "none",
      }}
      variant="contained"
    >
      <MdFilterList color="#2D5BFF" size={18} style={{ marginRight: 8 }} />
      Filtrar
    </Button>
  );
};

export default FilterButton;
